import { useAuthContext } from "components/context/authContext";
import JoinIntro from "components/view/join/intro";

export default function JoinIntroPage() {
  const { viewPort } = useAuthContext();

  return (
    <div className={"join-intro" + " " + viewPort?.screen}>
      <JoinIntro />
    </div>
  );
}
